var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2402_3489",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2402_3489)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 1,
    fill: "#5DAA22"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_2402_3489",
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -2,
    width: 31,
    height: 27,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -4,
    y: -2,
    width: 31,
    height: 27
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 11.5L23 0H0L11.5 11.5ZM11.5 11.5L0 23H23L11.5 11.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 11.5L23 0H0L11.5 11.5ZM11.5 11.5L0 23H23L11.5 11.5Z",
    fill: "#DD2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 0L23.8839 0.883883L26.0178 -1.25H23V0ZM0 0V-1.25H-3.01777L-0.883883 0.883883L0 0ZM0 23L-0.883883 22.1161L-3.01777 24.25H0V23ZM23 23V24.25H26.0178L23.8839 22.1161L23 23ZM22.1161 -0.883883L10.6161 10.6161L12.3839 12.3839L23.8839 0.883883L22.1161 -0.883883ZM0 1.25H23V-1.25H0V1.25ZM12.3839 10.6161L0.883883 -0.883883L-0.883883 0.883883L10.6161 12.3839L12.3839 10.6161ZM10.6161 10.6161L-0.883883 22.1161L0.883883 23.8839L12.3839 12.3839L10.6161 10.6161ZM0 24.25H23V21.75H0V24.25ZM23.8839 22.1161L12.3839 10.6161L10.6161 12.3839L22.1161 23.8839L23.8839 22.1161Z",
    fill: "white",
    mask: "url(#path-4-outside-1_2402_3489)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 17.25C13.8817 17.25 15.8125 14.6756 15.8125 11.5C15.8125 8.32436 13.8817 5.75 11.5 5.75C9.11827 5.75 7.1875 8.32436 7.1875 11.5C7.1875 14.6756 9.11827 17.25 11.5 17.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6201 9.99414L10.7751 10.5864L10.9365 9.33195L10.2529 8.44352H11.1976L11.6201 7.11914L12.0425 8.44352H12.9872L12.3036 9.33195L12.465 10.5864L11.6201 9.99414Z",
    fill: "#DD2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60396 13.8276L8.75902 14.4199L8.92039 13.1654L8.23682 12.277H9.18149L9.60396 10.9526L10.0264 12.277H10.9711L10.2875 13.1654L10.4489 14.4199L9.60396 13.8276Z",
    fill: "#DD2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6291 13.8276L12.7842 14.4199L12.9455 13.1654L12.262 12.277H13.2066L13.6291 10.9526L14.0516 12.277H14.9963L14.3127 13.1654L14.474 14.4199L13.6291 13.8276Z",
    fill: "#DD2C2C"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2402_3489)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2402_3489",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBif);
export default __webpack_public_path__ + "static/media/BIF.7c144382b0dcac102275f3ddd6b6b5d0.svg";
export { ForwardRef as ReactComponent };